import { StatAppStoreApi } from './categories/StatAppStoreApi/StatAppStoreApi';
import { StatBoomApi } from './categories/StatBoomApi/StatBoomApi';
import { StatShareApi } from './categories/StatShareApi/StatShareApi';
import { StatSubscriptionsApi } from './categories/StatSubscriptionsApi/StatSubscriptionsApi';

import { ICurrentUser } from '@interfaces';

import { IRouteData } from './types';

export class AppStat {

	protected static instance: AppStat = new AppStat();

	currentUser: ICurrentUser;

	routeData: IRouteData;

	subscriptions: StatSubscriptionsApi;

	boom: StatBoomApi;

	share: StatShareApi;

	stores: StatAppStoreApi;

	constructor() {
		if (AppStat.instance != null) {
			return AppStat.instance;
		}

		this.subscriptions = new StatSubscriptionsApi(this);
		this.boom = new StatBoomApi(this);
		this.share = new StatShareApi(this);
		this.stores = new StatAppStoreApi(this);
	}

	static get log() {
		return {
			subscriptions: this.instance.subscriptions,
			boom: this.instance.boom,
			share: this.instance.share,
			stores: this.instance.stores,
		};
	}

	static set currentUser(currentUser: ICurrentUser) {
		this.instance.currentUser = currentUser;
	}

	static set routeData(routeData: IRouteData) {
		this.instance.routeData = routeData;
	}

}
